export enum DashboardCardState {
  LOADED,
  NOT_LOADED,
  STALE
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/dashboard/dashboard-card-state.ts